import { render, staticRenderFns } from "./CreateLayetteIndex.vue?vue&type=template&id=6d3d4346"
import script from "./CreateLayetteIndex.vue?vue&type=script&lang=js"
export * from "./CreateLayetteIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports